import Api from '../../base/api.typings';
import axiosConfiguration from '../../base/axios-configuration';

class FinanceiroService {
    async listar(query: Api.App.Server.Financeiro.Listar.Query): Promise<Api.App.Server.Financeiro.Listar.Dto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Financeiro/Listar', { params: query }).then(e => e.data);
    }

    async listarAno(query: Api.App.Server.Financeiro.ListarAno.Query): Promise<Api.App.Server.Financeiro.ListarAno.Dto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Financeiro/ListarAno', { params: query }).then(e => e.data);
    }

    async importar(command: FormData): Promise<Api.App.Server.Financeiro.Importar.Dto> {
        await axiosConfiguration.configure();
        
        return axiosConfiguration.getAxios().post('/api/Financeiro/Importar', command, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(e => e.data);
    }

    async inserirEditar(command: Api.App.Server.Financeiro.InserirEditar.Command): Promise<number> {
        await axiosConfiguration.configure();
        
        return axiosConfiguration.getAxios().post('/api/Financeiro/InserirEditar', command).then(e => e.data);
    }
}
export default new FinanceiroService();